/**
 * Custom functionality for Product Detail page.
 */

/* global jQuery */

const ajaxAtc = require('../components/ajax-atc');

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

function productFunction() {
	// productFunction() description.

	// $( document ).ready(function() {
	// 	if ($('.featured-product__chip').length == 0) {
	// 		$('.excol-side__panel').css('position', 'relative');
	// 	}
	// });
}

exports.init = function() {
    // Shop page initialization.  $ is available here...

    ajaxAtc.init();
};